import React, { Component } from 'react';
import { Tooltip as ReactTooltip, OverlayTrigger } from 'react-bootstrap';

type TTooltipProps = {
    tooltip: React.ReactNode;
    placement?: 'top' | 'bottom' | 'left' | 'right';
    delayShow?: number;
    delayHide?: number;
    tooltipClassName?: string;
    overlayId?: string;
    children: React.ReactNode;
};

export default class Tooltip extends Component<TTooltipProps> {
    render() {
        const {
            tooltip,
            placement = 'top',
            delayShow = 300,
            delayHide = 150,
            tooltipClassName,
            overlayId = 'react-tooltip',
            children,
        } = this.props;

        const overlay = (
            <ReactTooltip id={overlayId} className={tooltipClassName}>
                {tooltip}
            </ReactTooltip>
        );

        return (
            <OverlayTrigger
                {...{ overlay, placement, delayShow, delayHide }}
            >
                {children}
            </OverlayTrigger>
        );
    }
}
